module.exports = __webpack_public_path__ + "img/logo.1d2ed91d.png";